import axios from 'axios';
import { debounce } from 'lodash';

class BrixInstagramFeed {
  static init(...parameters) {
    return new BrixInstagramFeed(...parameters);
  }

  constructor(block) {
    this.content = block.querySelector('.content');

    if (this.content) {
      this.restUrl = this.content.querySelector('.instagram-feed').dataset.restUrl;
      this.imageWrapper = this.content.querySelectorAll('.image-box');
      this.imageBoxes = this.content.querySelectorAll('.image-box img');

      if (this.restUrl) {
        this.fetchFeed();
      }

      window.addEventListener('resize', debounce(() => {
        if (this.images) {
          this.insertFeedImages();
        } else {
          this.insertFallbackImages();
        }
      }), 300);
    }
  }

  insertFeedImages() {
    if (this.images && this.imageBoxes.length > 0) {
      [...this.imageBoxes].forEach((imageBox, index) => {
        if (this.images[index] && this.images[index].media_url) {
          if (window.innerWidth < 576 && index > 3) {
            imageBox.parentElement.parentElement.classList.add('-hidden');
            return;
          }

          if (imageBox.src === '') {
            imageBox.setAttribute('src', this.images[index].media_url);
            // eslint-disable-next-line no-param-reassign
            imageBox.parentElement.parentElement.dataset.caption = this.images[index].caption;

            const link = document.createElement('a');
            link.setAttribute('href', this.images[index].permalink);
            link.setAttribute('target', '_blank');
            link.classList.add('link');

            imageBox.parentElement.parentElement.appendChild(link);

            setTimeout(() => {
              imageBox.classList.add('-visible');
            }, 100);
          }

          imageBox.parentElement.parentElement.classList.remove('-hidden');
        } else if (imageBox.dataset.fallbackImage) {
          if (imageBox.src === '') {
            imageBox.setAttribute('src', imageBox.dataset.fallbackImage);

            setTimeout(() => {
              imageBox.classList.add('-visible');
            }, 100);
          }
        }
      });
    }
  }

  insertFallbackImages() {
    if (this.imageBoxes.length > 0) {
      [...this.imageBoxes].forEach((imageBox, index) => {
        if (imageBox.dataset.fallbackImage) {
          if (window.innerWidth < 576 && index > 3) {
            imageBox.parentElement.parentElement.classList.add('-hidden');
            return;
          }

          if (imageBox.src === '') {
            imageBox.setAttribute('src', imageBox.dataset.fallbackImage);
            // eslint-disable-next-line no-param-reassign
            imageBox.parentElement.parentElement.dataset.caption = imageBox.dataset.fallbackCaption;

            imageBox.parentElement.parentElement.classList.remove('-hidden');

            setTimeout(() => {
              imageBox.classList.add('-visible');
            }, 100);
          }
        }
      });
    }
  }

  fetchFeed() {
    axios.get(`${this.restUrl}brix/v1/instagram-token/`)
      .then((response) => {
        if (response.data.token) {
          // First get the user ID
          axios.get(`https://graph.instagram.com/me?fields=id,username&access_token=${response.data.token}`)
            .then((userRes) => {
              if (userRes.data.id) {
                // Then get the media using the user ID
                axios.get(`https://graph.instagram.com/${userRes.data.id}/media?fields=id,media_type,media_url,thumbnail_url,permalink,caption&access_token=${response.data.token}`)
                  .then((mediaRes) => {
                    if (mediaRes.data.data) {
                      const filteredImages = mediaRes.data.data.filter((post) => post.media_type === 'IMAGE' || post.media_type === 'CAROUSEL_ALBUM');
                      this.images = filteredImages.slice(0, 8);
                      this.insertFeedImages();
                    } else {
                      this.insertFallbackImages();
                    }
                  })
                  .catch((error) => {
                    console.error('Instagram Media API Error:', error);
                    this.insertFallbackImages();
                  });
              } else {
                console.error('No user ID in response');
                this.insertFallbackImages();
              }
            })
            .catch((error) => {
              console.error('Instagram User API Error:', error);
              this.insertFallbackImages();
            });
        } else {
          this.insertFallbackImages();
        }
      })
      .catch(() => {
        this.insertFallbackImages();
      });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-instagram-feed', BrixInstagramFeed.init);
}
